import {RFValue} from 'react-native-responsive-fontsize';
import Ionicons from 'react-native-vector-icons/dist/Ionicons';
import styled from 'styled-components/native';

export const Container = styled.View`
  padding-horizontal: 24px;
  padding-top: 12px;
  padding-bottom: 8px;
  align-items: center;
`;

export const IconCircle = styled.View`
  width: ${RFValue(56)}px;
  height: ${RFValue(56)}px;
  border-radius: ${RFValue(28)}px;
  align-items: center;
  justify-content: center;
  margin-bottom: 16px;
  background-color: ${({theme}) => theme.colors.alert_blue_border};
`;

export const HeaderIcon = styled(Ionicons)`
  color: ${({theme}) => theme.colors.alert_blue_icon};
`;

export const Title = styled.Text`
  font-size: 18px;
  font-family: ${({theme}) => theme.fonts.semibold};
  text-align: center;
  margin-bottom: 8px;
  color: ${({theme}) => theme.colors.title};
`;

export const Subtitle = styled.Text`
  font-size: 14px;
  font-family: ${({theme}) => theme.fonts.regular};
  text-align: center;
  line-height: 22px;
  margin-bottom: 28px;
  color: ${({theme}) => theme.colors.text};
`;

export const PrimaryButton = styled.TouchableOpacity`
  width: 100%;
  padding-vertical: 16px;
  border-radius: 100px;
  align-items: center;
  margin-bottom: 12px;
  background-color: ${({theme}) => theme.colors.text_dark};
`;

export const PrimaryButtonText = styled.Text`
  color: ${({theme}) => theme.colors.buttonTitle};
  font-size: 16px;
  font-family: ${({theme}) => theme.fonts.semibold};
`;

export const GhostButton = styled.TouchableOpacity`
  width: 100%;
  padding-vertical: 12px;
  align-items: center;
`;

export const GhostButtonText = styled.Text`
  font-size: 14px;
  font-family: ${({theme}) => theme.fonts.regular};
  color: ${({theme}) => theme.colors.text};
`;
